/** @format */

import { useEffect, useState } from "react";
import { collection, getDocs, limit, query } from "firebase/firestore";
import { db } from "../firebase/config";

// Simple in-memory cache to avoid duplicate reads per session
const classroomsPresenceCache = new Map();

const useHasClassrooms = (courseId) => {
  const [hasClassrooms, setHasClassrooms] = useState(
    classroomsPresenceCache.get(courseId) ?? false
  );
  const [loading, setLoading] = useState(!classroomsPresenceCache.has(courseId));

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      if (!courseId) {
        setHasClassrooms(false);
        setLoading(false);
        return;
      }

      if (classroomsPresenceCache.has(courseId)) {
        setHasClassrooms(classroomsPresenceCache.get(courseId));
        setLoading(false);
        return;
      }

      try {
        const q = query(
          collection(db, "courses", courseId, "Classrooms"),
          limit(1)
        );
        const snap = await getDocs(q);
        const exists = snap.size > 0;
        classroomsPresenceCache.set(courseId, exists);
        if (!cancelled) setHasClassrooms(exists);
      } catch (_) {
        if (!cancelled) setHasClassrooms(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    check();
    return () => {
      cancelled = true;
    };
  }, [courseId]);

  return { hasClassrooms, loading };
};

export default useHasClassrooms;


